// Platform taxonomy for the Scope 3 Category 5 waste module, mirrored for dropdowns.
// Source of truth: ecoprismapi/Helper/Modules/Scope3/WasteConstants.cs — keep the strings identical,
// the API canonicalises free text against them.

export const WASTE_METRIC = "Waste Generated in Operations";

export const WASTE_CATEGORIES = ["Hazardous", "Non-hazardous"];

export const WASTE_TYPES = [
  "Metal scrap",
  "Wood / pallets",
  "Plastic (rigid)",
  "Plastic film",
  "Cardboard / paper",
  "Glass",
  "Mixed general waste",
  "Food / canteen waste",
  "Used oil",
  "Spent solvent",
  "Paint sludge",
  "ETP sludge",
  "Contaminated PPE",
  "Batteries",
  "E-waste",
];

export const ANY_DISPOSAL_METHOD = "*";

export const DISPOSAL_METHODS = [
  "Recycling",
  "Recycling (re-refining)",
  "Reuse",
  "Composting",
  "Anaerobic digestion",
  "Incineration with energy recovery",
  "Landfill",
];

/** GRI 306-4 recovery operations; everything else is directed to disposal. */
export const DIVERTED_METHODS = ["Recycling", "Recycling (re-refining)", "Reuse", "Composting", "Anaerobic digestion"];

export const GWP_BASES = ["AR5", "AR6", "AR4"];

export const ADD_SUPPLIER_FACTOR_ACTION = "AddSupplierFactor";

export const isDivertedMethod = (method) => DIVERTED_METHODS.includes(method);
